/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {ExdsIconCheckmark, ExdsIconMinus} from "@exds/icons";
import {TuxIcon} from "@tuxedo/react-component-library";
import {ExdsText} from "@exds/core";
import parse from "html-react-parser";
import XRegExp from "xregexp";
import warningIcon from "@tuxedo/jpmc-theme/images/icons/warning.svg";
import {sanitizedHtml} from "../../../utils/utils";

export default function Requirement(props) {
  const {req, passwordValue, key} = props;

  const validateInputValue = (value, regex) => {
    if (!value) return false;
    const xreg = XRegExp(regex);
    return xreg.test(value);
  };

  const isValid = validateInputValue(passwordValue, req.regex);
  const textStyle = passwordValue && !isValid ? 'bodyMediumHeavier' : 'bodyMedium';

  return (
    <div className='req' key={key}>
      {!passwordValue && <ExdsIconMinus color="regular" size="medium" aria-label="Requirement not evaluated"/>}
      {passwordValue && isValid && <ExdsIconCheckmark color="regular" size="medium" aria-label="Requirement met" />}
      {passwordValue && !isValid && <TuxIcon svg={warningIcon} className="warning-icon" variant="danger" aria-label="Requirement not met" />}
      <ExdsText
        textStyle={textStyle}
        className={`req-text w-100 ${passwordValue && !isValid ? 'invalid-text' : ''}`}
      >
        {parse(sanitizedHtml(req.description))}
      </ExdsText>
    </div>
  );

};
